import Button from 'components/Button';
import Error from 'components/form/Error';
import ActionModal from 'components/Modal/ActionModal';
import Space from 'components/Space';
import { MenteeStatusValues } from 'enums/MenteeStatus';
import { MentorshipStatusValues } from 'enums/MentorshipStatus';
import { FC, useContext, useState } from 'react';
import styled from 'styled-components';
import { mutate } from 'swr';
import privateAPI from 'utils/privateAxiosInstance';
import { ButtonsContainer } from '.';
import { MentoringContext } from '..';
import { MenteeEditContext } from '../..';

const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  & > * {
    margin-bottom: 1rem;
  }
  margin-bottom: 1rem;
`;

const Interrupted: FC = () => {
  const { mentorship } = useContext(MentoringContext);
  const { mentee } = useContext(MenteeEditContext);
  const [eligibleLoading, setEligibleLoading] = useState(false);
  const [finishLoading, setFinishLoading] = useState(false);
  const [refuseLoading, setRefuseLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);

  const handleFinish = () => {
    setFinishLoading(true);
    setError(false);
    privateAPI
      .put(`/mentorship/${mentorship?.id}`, {
        status: 'FINISHED_ADMIN' as MentorshipStatusValues,
      })
      .then(() => {
        mutate(`/mentorship/mentee/${mentorship!.menteeId}`);
        mutate(`/mentorship/mentee/${mentorship!.menteeId}/ongoing`);
      })
      .catch(() => {
        setFinishLoading(false);
        setError(true);
      });
  };

  const handleSetElligible = () => {
    setEligibleLoading(true);
    setError(false);
    privateAPI
      .patch(`/user/status/${mentee?.id}`, {
        menteeStatus: 'ELIGIBLE' as MenteeStatusValues,
      })
      .then(() => {
        mutate(`/user/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}/ongoing`);
      })
      .catch(() => {
        setEligibleLoading(false);
        setError(true);
      });
  };

  const [refuseOpen, setRefuseOpen] = useState<boolean>(false);
  const handleRefuse = () => {
    setRefuseLoading(true);
    setError(false);
    privateAPI
      .patch(`/user/status/${mentee?.id}`, {
        menteeStatus: 'REFUSED' as MenteeStatusValues,
      })
      .then(() => {
        mutate(`/user/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}`);
        mutate(`/mentorship/mentee/${mentee!.id}/ongoing`);
        setRefuseOpen(false);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setRefuseLoading(false);
      });
  };

  return (
    <>
      <div>
        <ActionContainer>
          <p>
            Le mentorat a été interrompu. Quelle action souhaitez-vous effectuer
            ?
          </p>
          <ButtonsContainer>
            <Button
              color="primary"
              onClick={handleSetElligible}
              loading={eligibleLoading}
            >
              Créer un nouveau mentorat
            </Button>
            <Button
              color="primary"
              onClick={handleFinish}
              loading={finishLoading}
            >
              Terminer le mentorat
            </Button>
            <Button
              color="primary"
              onClick={() => {
                setRefuseOpen(true);
              }}
            >
              Refuser le mentorat
            </Button>
          </ButtonsContainer>
          {error && <Error>Une erreur est survenue.</Error>}
        </ActionContainer>
      </div>
      <ActionModal
        open={refuseOpen}
        close={() => setRefuseOpen(false)}
        title="Refuser le mentorat"
        color="error"
        apply={handleRefuse}
        loading={refuseLoading}
      >
        {error && (
          <>
            <Error>Une erreur est survenue.</Error>
            <Space height={0.5} />
          </>
        )}
        Vous êtes sur le point de refuser le mentorat à ce mentoré.
        <br />
        Il n'apparaîtra alors plus dans la liste des mentorés à associer.
        <br />
        <br />
        Cette action est réversible.
        <br />
        <br />
        Souhaitez-vous continuer ?
      </ActionModal>
    </>
  );
};

export default Interrupted;
